/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './device';
import './shared/device_profile_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "DeviceProfileLink": {
                        "fields": {
                          "device": {
                            "type": ".squareup.devicesettings.profiles.v2.model.Device",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfileToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.DeviceProfileLink) {
  $root.addJSON(jsonData);
}

/**
 * DEPRECATED! DO NOT USE! Use /shared/device_profile_link.proto instead.
 *
 * SOURCE DeviceProfileLink @ squareup/devicesettings/profiles/v2/model/device_profile_link.proto at 15:1
 */
export const DeviceProfileLink = $root.lookupType('squareup.devicesettings.profiles.v2.model.DeviceProfileLink');
fixType(DeviceProfileLink, {
  device: {
    required: true
  },
  deviceProfileToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DeviceProfileLink);